module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Not Found")]), _vm._v(" "), _c('div', {
    staticClass: "font-lg"
  }, [_c('p', [_vm._v("The page you requested could not be found.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c615756","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = LTK2
// module chunks = 1